import { translate } from "app/language/service"
import { getStore } from "app/store/store"
import { IAppMessageOptions, JAPP_MESSAGE_SEVERITIES } from "message/model"
import { messageActionCreator } from "message/store/action"

export function closeConfirmMessagePopup(): void {
  getStore().dispatch(messageActionCreator.setConfirmMessage(undefined))
}

export function getMessageOptionsWithSeverity(
  severity: JAPP_MESSAGE_SEVERITIES,
  options?: IAppMessageOptions
): IAppMessageOptions {
  if (options !== undefined && typeof options !== "object") {
    throw Error("Parameter options must be an object")
  }
  if (!options) {
    options = {}
  }
  options.severity = severity
  return options
}

export function addGenericConfirmationMessage(message: string | string[]): string | string[] {
  if (typeof message === "string") {
    message = [message]
    message.push(translate("label.continue.confirmation"))
  } else if (Array.isArray(message)) {
    message.push(translate("label.continue.confirmation"))
  }
  return message
}
